export default {
    toolsProfit:{
        calculate: '计算',
        CustomerDetails: '客户明细',
        Storage: '日均存储',
        PostageMargin: '物流利润',
        WeeklyOrder: '每周订单',
        ProfitComparison: '利润比较',
        ComparisonItem: '项目比较',
        SampleCompany: '样本公司',
        PotentialCustomer: '对照公司',
        ChargeItems: '收费项',
        SlendierPrice: '公司价格',
        Quote: '报价',
        industry: '行业',
        ClientTemplate: '收费项模板',
        BorC: 'B或C',
        dataRange: '数据范围',
        DataModel: '数据模型',
        PotentialUserProfitPrediction: '潜在客户利润预测',
        ExistingCustomerProfitAdjustment: '存量用户利润调整',
        timePeriod: '时段'
    }
}